import { Box, styled } from '@mui/material';

export const MainBox = styled(Box)(({ theme }) => ({
    padding: '30px 25px 25px',
    maxWidth: '377px',
    height: '250px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    marginTop: '30px',
    [theme.breakpoints.down('lg')]: {
        marginTop: '10px',
        padding: '40px 25px 25px',
        maxWidth: '455px',
    },
}));

export const IconsBox = styled(Box)(() => ({
    display: 'flex',
    gap: '14px',
}));
